module.exports = __webpack_public_path__ + "static/Vabysmo_logo_EN-36262d1fa5e3f963eae0073b2a78fde9.svg";